module.exports = __webpack_public_path__ + "static/media/hulu-wide.57ad79a6.png";